function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { useEffect, useState, useMemo } from 'react';
import styled, { css } from 'styled-components';
import { Favorite } from '@styled-icons/material/Favorite';
import { FavoriteBorder } from '@styled-icons/material-outlined/FavoriteBorder';
import { spacing, icons, themeLight } from '@naf/theme';

// TODO: Add animation onClick.

export const FavoriteButton = ({
  isFavorite = false,
  isLoading = false,
  onClick,
  className,
  ...rest
}) => {
  const [mouseDown, setMouseDown] = useState(false);
  const removeOutline = () => {
    setMouseDown(true);
  };
  const addOutline = e => {
    if (e.key === 'Tab') {
      setMouseDown(false);
    }
  };
  useEffect(() => {
    window.addEventListener('mousedown', removeOutline);
    return () => window.removeEventListener('mousedown', removeOutline);
  }, []);
  useEffect(() => {
    window.addEventListener('keydown', addOutline);
    return () => window.removeEventListener('keydown', addOutline);
  }, []);
  const a11yLabel = !isFavorite ? 'Legg til favoritt' : 'Fjern fra favoritter';
  const HeartIcon = useMemo(() => {
    if (isFavorite) {
      return /*#__PURE__*/React.createElement(Favorite, null);
    } else {
      return /*#__PURE__*/React.createElement(FavoriteBorder, null);
    }
  }, [isFavorite]);
  if (onClick === undefined) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Container, _extends({
    onClick: () => onClick(isFavorite),
    className: className,
    id: mouseDown ? 'mousedown' : '',
    "aria-label": a11yLabel,
    isFavorite: isFavorite
  }, rest), HeartIcon);
};
export default FavoriteButton;
const Container = styled.button.withConfig({
  displayName: "FavoriteButton__Container",
  componentId: "sc-1i7krxh-0"
})(["border:none;margin:0;padding:0;width:auto;overflow:visible;background:transparent;color:inherit;font:inherit;line-height:normal;appearance:none;touch-action:manipulation;width:", ";height:", ";background:white;display:flex;justify-content:center;align-items:center;border-radius:50%;cursor:pointer;&:active{border-radius:50% !important;}svg{font-size:", ";color:", ";", "}&#mousedown{outline:0;}"], spacing.space24, spacing.space24, icons.s, ({
  theme
}) => theme.typography ? theme.typography.defaultText : themeLight.typography.defaultText, ({
  isFavorite
}) => isFavorite && css(["color:", ";"], ({
  theme
}) => theme.typography ? theme.typography.textLink : themeLight.typography.textLink));
//# sourceMappingURL=FavoriteButton.js.map